// extracted by mini-css-extract-plugin
module.exports = {"main":"ServiceInformation_main__7yCKx","heading":"ServiceInformation_heading___E1GI"};